import { useTranslation } from "react-i18next";
import { getPuzzleType } from "@/puzzle-types/registry";

/**
 * Opens the puzzle's PDF sheet in its own tab, so the running attempt stays where it is.
 * The core only knows that a type *may* draw itself on paper; one that cannot says so here.
 */
export function SheetLink({
  slug,
  puzzleType,
  teamId = null,
}: {
  slug: string;
  puzzleType: string;
  /** The sheet of a team attempt is found through the same `?team=` as the play page. */
  teamId?: number | null;
}) {
  const { t } = useTranslation();
  const available = Boolean(getPuzzleType(puzzleType)?.PrintView);
  return (
    <div className="bt-sheet-link">
      {available ? (
        <a
          className="bt-button bt-button--outline bt-button--md"
          href={`/puzzles/${slug}/sheet${teamId ? `?team=${teamId}` : ""}`}
          target="_blank"
          rel="noopener"
        >
          {t("play.sheet")}
        </a>
      ) : (
        <span className="bt-sheet-link__note">{t("play.sheet_unavailable")}</span>
      )}
    </div>
  );
}
